var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "claim-examine"
  }, [_vm.procedureList.length != 0 ? _c("div", {
    staticStyle: {
      width: "100px",
      "margin-right": "20px"
    }
  }, [_c("procedure", {
    attrs: {
      list: _vm.procedureList,
      step: _vm.step + 1
    }
  })], 1) : _vm._e(), _vm.scheduleList.length != 0 ? _c("div", {
    staticStyle: {
      width: "200px",
      "overflow-y": "auto"
    }
  }, [_c("schedule", {
    attrs: {
      list: _vm.scheduleList,
      scheduleInfo: _vm.scheduleInfo
    },
    on: {
      go: _vm.goInfoFun
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "infoBox",
    staticStyle: {
      flex: "1"
    }
  }, [_c("div", {
    staticClass: "name",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.scheduleInfo.name)))]), _vm.detailsObj ? _c("div", {
    class: {
      detailsObj: "operationBox"
    }
  }, [_vm.detailsObj.renderState == "COPYWRITING" ? _c("div", {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c("a-result", {
    attrs: {
      status: "warning"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c("a-icon", {
          style: {
            color: "#000"
          },
          attrs: {
            type: _vm.detailsObj.copywritingInfo.copywritingIconName
          }
        })];
      },
      proxy: true
    }, {
      key: "extra",
      fn: function () {
        return [_c("div", {
          staticClass: "cont"
        }, [_vm._v(" " + _vm._s(_vm.$t(_vm.detailsObj.copywritingInfo.copywriting)) + " ")])];
      },
      proxy: true
    }], null, false, 2887839040)
  })], 1) : _vm._e()]) : _vm._e(), _vm.detailsObj && _vm.detailsObj.sharedNodeInfo && _vm.detailsObj.sharedNodeInfo.length ? _c("shared-node", {
    ref: "sharedNode",
    attrs: {
      sharedNodeInfo: _vm.detailsObj.sharedNodeInfo || [],
      policyInfo: _vm.policyInfo,
      echoNodeIsEdit: _vm.echoNodeIsEdit
    }
  }) : _vm._e(), _vm.detailsObj && _vm.detailsObj.editableAreaInfo && _vm.detailsObj.editableAreaInfo.length ? _c("current-node", {
    ref: "currentArea",
    attrs: {
      editableArea: _vm.detailsObj.editableAreaInfo || [],
      echoNodeIsEdit: _vm.crrentNodeIsEdit
    }
  }) : _vm._e(), _vm.$route.params.type == 2 && _vm.detailsObj && _vm.detailsObj.actionButton.length != 0 ? _c("div", {
    staticClass: "btnBox"
  }, _vm._l(_vm.detailsObj.actionButton, function (item, index) {
    return _c("a-button", {
      key: index,
      staticClass: "marginL15",
      attrs: {
        type: item.color,
        loading: _vm.loading
      },
      on: {
        click: function ($event) {
          return _vm.onSubmit(item);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1) : _vm._e()], 1), _vm.showSendEmail ? _c("email-send-model", {
    attrs: {
      notifyData: _vm.notifyData,
      visible: _vm.showSendEmail
    },
    on: {
      closeModel: _vm.closeModel,
      "update:visible": function ($event) {
        _vm.showSendEmail = $event;
      },
      cancel: function ($event) {
        _vm.showSendEmail = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };